import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from './modal.service';
import { ModalSharedComponent } from './default/modal.component';
import { ModalSecondarySharedComponent } from './secondary/modal-secondary.component';
import { IconSharedModule } from './../../atoms/entry';

@NgModule({
    declarations: [
        ModalSharedComponent,
        ModalSecondarySharedComponent,
    ],
    imports: [
        CommonModule,
        NgbModalModule,
        IconSharedModule
    ],
    exports: [
        ModalSharedComponent,
        ModalSecondarySharedComponent,
    ],
    providers: [
        ModalService
    ]
})

export class ModalSharedModule {}
